var map = {
	"./akiles.png": 8318,
	"./assa abloy.png": 84314,
	"./omnitec os access.png": 14112,
	"./omnitec rent&pass.png": 55870,
	"./padword.png": 88858,
	"./salto ks.png": 5098,
	"./salto.png": 59838,
	"./tesa.png": 7404,
	"./ttlock.png": 23344,
	"./yacan.png": 22017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;